import { render, staticRenderFns } from "./principle.vue?vue&type=template&id=04ff6d55&"
import script from "./principle.vue?vue&type=script&lang=js&"
export * from "./principle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports